export default function About() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full">
            <div className="relative rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20modern%20home%20theater%20setup%20with%20large%20screen%20displaying%20abstract%20golden%20cinematic%20light%2C%20comfortable%20seating%2C%20dim%20ambient%20lighting%2C%20dark%20walls%20with%20subtle%20gold%20accents%2C%20cozy%20atmosphere%2C%20premium%20viewing%20experience%2C%20no%20text&width=960&height=640&seq=about-cinema-03&orientation=landscape"
                alt="八戒电影网 高清在线观影平台"
                className="w-full h-auto object-cover rounded-xl"
              />
            </div>
          </div>
          <div className="flex-1 w-full">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">关于八戒</h2>
            <p className="mt-4 text-foreground-400 text-sm md:text-base leading-relaxed">
              八戒电影网创立于2019年，是一个专注于高清影视资源在线观看的专业平台。
              我们深知影迷对观影体验的高要求——不缓冲、无广告、快速加载是八戒电影网的立站之本。
            </p>
            <p className="mt-3 text-foreground-400 text-sm md:text-base leading-relaxed">
              平台依托高速服务器集群与智能CDN分发技术，确保无论何时何地，你都能享受流畅的高清观影体验。
              从院线大片到冷门佳作，从经典老片到最新剧集，片库持续更新，让每一位影迷都能找到心仪的内容。
            </p>
            <div className="mt-5 grid grid-cols-3 gap-3">
              <div className="p-3 bg-background-100 rounded-lg text-center border border-background-200/60">
                <div className="font-heading text-xl font-bold text-primary-400">12,000+</div>
                <div className="text-foreground-600 text-xs mt-0.5">影片资源</div>
              </div>
              <div className="p-3 bg-background-100 rounded-lg text-center border border-background-200/60">
                <div className="font-heading text-xl font-bold text-primary-400">99.9%</div>
                <div className="text-foreground-600 text-xs mt-0.5">播放流畅率</div>
              </div>
              <div className="p-3 bg-background-100 rounded-lg text-center border border-background-200/60">
                <div className="font-heading text-xl font-bold text-primary-400">0</div>
                <div className="text-foreground-600 text-xs mt-0.5">广告打扰</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}